export const SET_UI_DIMENSIONS = 'SET_UI_DIMENSIONS';
export const RESET_WEBRTC_CALL_START = 'RESET_WEBRTC_CALL_START';
